import React from 'react';
import { useTranslation } from 'react-i18next';
import { FormikState } from 'formik';
import SelectField, {
  SelectFieldOption,
} from 'components/form-fields/formik/SelectField';
import TextArea from 'components/form-fields/formik/TextArea';
import { TariffDescription } from 'screens/GroupsAndPolicies/types';

type Props = {
  values: FormikState<TariffDescription>['values'];
  getAvailableLanguages: (language: string) => SelectFieldOption[];
};

export const TariffDescriptionFormFields: React.FC<Props> = ({
  values,
  getAvailableLanguages,
}) => {
  const { t } = useTranslation();

  return (
    <>
      <SelectField
        name="language"
        options={getAvailableLanguages(values?.language)}
        label={t('formLabel.language', 'Language')}
        style={{ maxWidth: '20rem', marginBottom: '1rem' }}
        required
      />
      <TextArea
        name="text"
        label={t('tariffProfile.customTariffDescription', 'Description')}
        max={512}
        required
      />
    </>
  );
};
